import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { apiRequest } from 'app/utils/request/api';

type GetBrandsParams = {
  limit: number;
  search: string;
};

const path = 'experiences/brands' as const;

export function useGetBrands(brandParams: GetBrandsParams) {
  const key = useMemo(() => {
    return [
      path,
      {
        brandParams,
      },
    ];
  }, [brandParams]);

  return useQuery({
    queryKey: key,
    queryFn: () =>
      apiRequest({
        path,
        queryParams: brandParams,
      }) as Promise<string[]>,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    placeholderData: keepPreviousData,
    meta: { errorMessage: 'Error fetching Experiences Brands' },
  });
}
